<script>
import { commands } from '../../js/lib/functions.js'
import { navigate } from '@trullock/page-manager'
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { showToast } from '../../js/utils/toast.js';
import { listenToCurrentUserView } from '../../js/readModel.js';

export const pageName = 'account-licensing';
export const pageRoute = '/account/licensing';
export const title = 'Licensing';

export default {
	data() {
		return { 
			storeLimit: 5000,
			singleMotorLimit: true,

			isDirty: false,
			ready: false,
		}
	},
	methods: {
		beforeHide() {
			return this.isDirty ? 'Are you sure you want to abandon your changes?' : null
		},
		async boot(opts) {
			await listenToCurrentUserView(user => this.user = user);
		},
		async show()
		{
			commands.warmUp();

			this.storeLimit = this.user.licensing.storeLimit;
			this.singleMotorLimit = this.user.licensing.singleMotorLimit

			this.ready = true;
			this.isDirty = false;
		},
		changed() {
			this.isDirty = true;
		},
		async submit() {
			
			showLoading();

			// new need copies because the update listener replaces the new values
			let newLimit = this.storeLimit
			let result = await commands.users.licensing.changeLicensing({ storeLimit: newLimit, singleMotorLimit: this.singleMotorLimit });
			if(!result.success)
			{
				showToast({ message: 'Error changing your name', style: 'bg-danger'})
				hideLoading();
				return;
			}

			this.isDirty = false;

			navigate('/inventory/motors')

			showToast({
				message: 'Licensing updated',
				style: 'bg-success'
			})

			hideLoading();
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
    <form @submit.prevent="submit" @change="changed">
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 my-5">
				<h1 class="display-4 text-center mb-3">Licensing</h1>
				<p class="text-muted text-center mb-5">Tell us about your license information.</p>
					
				<div class="form-group">
					<label class="form-label">
						Rocket motor store limit
					</label>
					<div class="input-group has-validation">
						<input type="number" min="1" max="99999" step="1" autocomplete="off" v-model="storeLimit" class="form-control" required placeholder="e.g. 5000" />
						<div class="input-group-append">
							<div class="input-group-text">
								g
							</div>
						</div>
						<span class="invalid-feedback"></span>
					</div>
						<span class="form-text text-muted small mb-0">You <a href="https://ukra.org.uk/info/legal/rocket-motors-and-the-law/" target="_blank">may keep upto 5kg <span class="fe fe-external-link"></span></a> of rocket motors without an explosives license. If you have increased that with a license, specify your permitted limit here so we can <a href="/inventory/motors" target="_blank">help you keep track of your utilisation <span class="fe fe-external-link"></span></a>.</span>
				</div>
				<div class="form-group mb-4">
					<div class="custom-control custom-switch">
						<input type="checkbox" class="custom-control-input" v-model="singleMotorLimit">
						<label class="custom-control-label d-block">Single motor NEQ limited to 1kg</label>
					</div>
					<span class="form-text text-muted small mb-0">You <a href="https://ukra.org.uk/info/legal/rocket-motors-and-the-law/" target="_blank">may only store individual rocket motors upto 1kg net equivalent quantity each <span class="fe fe-external-link"></span></a> without an explosives license. If you have increased that with a license, untick this box so we can <a href="/inventory/motors" target="_blank">help you keep track of your utilisation <span class="fe fe-external-link"></span></a>.</span>
				</div>
				<hr class="my-5" />
				<button type="submit" class="btn btn-lg btn-primary btn-block">Save changes <span class="fe fe-check-circle"></span></button>
			</div>
		</div>
	</form>
</div>
</template>